<template>
  <div class="concept-base">
      <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: "UserConcept"
  }
</script>

<style scoped>
.concept-base{
  height: 91vh;
  background: #FFFFFF;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1), 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
  border-radius: 2px;
  margin-top: 10px;
  padding: 10px;
}
</style>